import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';

export type Props = {
  dataTestId?: string;
  className?: string;
  label: string;
};

const Service: React.FCC<Props> = ({ dataTestId, className, label }) => (
  <JustificationContainer
    dataTestId={dataTestId}
    className={className}
    padding={['xxs', 'xs']}
    border={{
      radius: 'base',
      color: { group: 'tertiary' },
      width: 's',
    }}
    width="max-content"
  >
    <Body margin={[null]} size="s">
      {label}
    </Body>
  </JustificationContainer>
);

export default Service;
